import React, { useState } from 'react'
import { ToastContainer } from 'react-toastify'
import MainCellEntry from './MainCellEntry'
const MovieRow = props => {
    const { mode, columns, data, onChange, rowIndex, updatedMovieData11 } = props
    const [pathValue, setPathValue] = useState()
    return (
      <>
        <tr>
          {columns.map(({ path }, index, columnIndex) => {
            const handleChange = (value, indexValue) => {
              if (onChange) {
                const changedData = { ...data, [path]: value }
                setPathValue({ [path]: value })
                onChange(columnIndex, changedData)
                const params = {
                  path,
                  value,
                  changedData,
                  indexValue,
                }
                updatedMovieData11(params)
              }
            }

            return (
              <>
                <MainCellEntry
                  // movieAndWebSeries={props.movieAndWebSeries}
                  rolename={props.rolename}
                  personIdval={props.personIdval}
                  setLocalMode={props.setLocalMode}
                  localMode={props.localMode}
                  setpersonIdval={props.setpersonIdval}
                  setRolename={props.setRolename}
                  columns={columns}
                  path={path}
                  mode={mode}
                  data={data}
                  pathValue={pathValue}
                  handleChange={handleChange}
                  rowIndex={rowIndex}
                />
              </>
            )
          })}
        </tr>
        <ToastContainer
          position='top-right'
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          rtl={false}
        />
      </>
    )
  }

  export default MovieRow
